import { PreAuthRoute as Route, SentryRoute, useRouteMatch, ControllerWrapper } from "extensions/react-router";

import { LoginController } from "./loginController";

const controller = new LoginController();

export function LoginRouter() {
    const { url } = useRouteMatch();

    return (
        <>
            {/* The following routes will redirect to start page if the user is already logged in */}
            <Route path={`${url}/login`} render={() => <ControllerWrapper controller={controller} method="login" />}/>
            <Route path={`${url}/login/provider/:id`} render={() => <ControllerWrapper controller={controller} method="loginWithProvider" />}/>
            <Route path={`${url}/reset`} render={() => <ControllerWrapper controller={controller} method="reset" />}/>
            <Route path={`${url}/new_user`} render={() => <ControllerWrapper controller={controller} method="new_user" />}/>
            <Route path={`${url}/saml`} render={() => <ControllerWrapper controller={controller} method="saml_user" />}/>
            <Route path={`${url}/saml_error`} render={() => <ControllerWrapper controller={controller} method="saml_error" />}/>

            {/* The following route will redirect to login if the user is not already logged in */}
            <SentryRoute path={`${url}/logout`} render={() => <ControllerWrapper controller={controller} method="logout" />}/>
        </>
    );
}
